export const BASE_WEBSITE_URL = "https://vicdesign.es";
export const TAB_WEB_NAME = 'vicdesign';
export const CACHE_FILE_NAME = 'vicdesign';